<script>
import { parseShiftRaw, parseRepeatShiftTemplateOplusTimeRaw } from "../legacy/parser/shiftParser";
import { shiftName, shiftHasLinkPrev, shiftHasLinkNext } from '../view/shift/shift';
import { SLOT_TYPES } from '../js/models';
import GroupRoleIcon from './icons/GroupRoleIcon.vue';
import SlotBadges from "./components/SlotBadges.vue";
import { addDaysToDate, goDateString } from '../js/common';
import { isSlotTypeXOffDayString, isSlotGroupRole, isClone, getSlotToDateString } from '../js/slot_helpers';
import { updateSelectedSlotsCount, findRoleById, findUserById } from '../js/summary_lib';
import { dateFromString, kitchenTimeToDuration } from "../common/common";
import timeZones from "../common/timeZones";
import { makeTableDate } from "../table/v1/table";
import periodTypes from "../table/v1/periodTypes";
import { repeatShiftsFromTemplate } from "../employmentShiftTable/employmentShiftTable";
import { MeStore } from "../store/v1/meStore";
import OrMainRoleIcon from "./icons/OrMainRoleIcon.vue";
import AutoIcon from "../view/assets/icons/AutoIcon.vue";
import OrSubRoleIcon from "./icons/OrSubRoleIcon.vue";
import { hexToRgb } from "../common/common";
import { summaryTablePresenterInjectKey } from "../provider/provider";

export default {
    props: {
        slot: Object,
        branchSettings: Object,
        durationBeforeLastShiftBySlotId: Object,
        date: String,
        repeatDate: Date,
        meStore: MeStore,
        scheduleIntervals: Array,
        isCellDisabled: {
          type: Boolean,
          default: false,
        },
        // used in shift page, always false in summary page
        isUsedInShiftPage: {
          type: Boolean,
          default: false,
        },
        emitOnMount: {
          type: Boolean,
          default: false,
        },
        isReadOnly: {
          type: Boolean,
          default: false,
        },
        exceedWeeklyLimit: {
          type: Boolean,
          default: false,
        }
    },
    inject: {
        deleteMode: 'deleteMode',
        cellEditMode: 'cellEditMode',
        slotLogMap: 'slotLogMap',
        useShiftBorders: 'useShiftBorders', // Browser setting for enabling dashed borders for unconfirmed shifts
        roleStore: 'roleStore',
        summaryTablePresenter: { from: summaryTablePresenterInjectKey, default: undefined },
    },
    emits: [
      'mounted',
      'unmounted',
    ],
    methods: {
        handleSlotClick() {
            if (this.summaryTablePresenter && this.summaryTablePresenter.isLockedBySchedule(this.slot.Date, getSlotToDateString(this.slot))) {
              this.summaryTablePresenter.promptUnlock(this.slot.Date, getSlotToDateString(this.slot), () => this.handleSlotClick())
              return;
            }

            if (this.isReadOnly) {
              alert("シフトを読み込み中のため、現在シフトの編集はできません。読み込み完了後に、再度お試しください。");
              return;
            }
            if (this.isClone || this.cellEditMode.isOn || this.isCellDisabled) {
                return;
            }

            if (!this.isUsedInShiftPage && !this.meStore.getIsLeader()) {
              return;
            }

            if (this.deleteMode.isOn) {
                if (this.slot.Repeat) {
                    alertModal.alert("リピートシフトは削除できません。");
                    return;
                }
                this.toggleSelectedDelete();
                return;
            }

            let dateUnix = this.slot.DateUnix;
            if (this.isRepeat) {
                dateUnix = this.repeatDate / 1000;
            };

            if (this.isUsedInShiftPage) {
              // Open ask modal if shift has not been accepted or rejected yet by staff
              if (this.slot.AskStatus === 1) {
                handleOpenAskSlotModal(dateUnix, this.slot.ID, `${this.slot.DateLabel}`,`${this.slot.TextNoTime} ${this.slot.Label}`);
                return;
              }

              openShiftSlotModal(dateUnix, this.slot.ID);
              return
            }
            openSlotModal(dateUnix, this.slot.UserID, this.slot.ID)
        },
        toggleSelectedDelete() {
            const selectedSlots = this.deleteMode.selectedSlots
            if (this.isSlotSelectedForDelete) {
                const slotIndex = selectedSlots.indexOf(this.slot.ID);
                selectedSlots.splice(slotIndex, 1);
            } else {
                selectedSlots.push(this.slot.ID)
            }
            updateSelectedSlotsCount();
        },
        // Params: raw slot, TableDate, timezone string. Returns Shift model or undefined.
        computeRepeatShift(slot, tableDate, userTz) {
          const repeatTemplate = parseRepeatShiftTemplateOplusTimeRaw(slot, userTz);
          // +- a day on either side to catch overnight slots
          const shifts = repeatShiftsFromTemplate(addDaysToDate(tableDate.getDate(), -1), addDaysToDate(tableDate.getEnd(), 1), repeatTemplate, userTz);

          return shifts[0];
        },
        // Params: date string, timezone string. Returns TableDate
        computeTableDate(date, userTz) {
          const dateInTz = dateFromString(date, userTz);
          return makeTableDate(dateInTz, periodTypes.DAY, userTz);
        },
    },
    created() {

    },
    mounted() {
      if (!this.$props.emitOnMount) {
        return;
      }
      this.$emit('mounted', {el: this.$el})
    },
    updated() {

    },
    beforeUnmount() {
      if (!this.$props.emitOnMount) {
        return;
      }

      this.$emit('unmounted', {el: this.$el})
    },
    computed: {
        computedSlot() {
          let slot = this.slot
          if (this.showRequestSlotOnly && this.slot.RequestedSlot) {
            slot = this.slot.RequestedSlot
          }
          return slot;
        },
        isSlotSelectedForDelete() {
            return this.deleteMode?.isOn && this.deleteMode?.selectedSlots?.includes(this.slot.ID);
        },
        hasBeenReadClass() {
          return {
            "is-not-read" : !this.computedSlot.IsRead && this.meStore.getIsLeader(),
          };
        },
        overTimeClass() {
          if (!this.computedSlot.From || !this.computedSlot.To) {
            return {};
          }

          const differenceMs = new Date(this.computedSlot.To).getTime() - new Date(this.computedSlot.From).getTime();

          let restMs = 0;
          const rawRest = this.computedSlot.Rest;
          if (rawRest && rawRest !== "0") {
            restMs = kitchenTimeToDuration(rawRest, "minutes") * 60 * 1000;
          }

          // If the Rest field is zero, fall back to summing rest sections (matching stats.ts logic)
          if (restMs === 0 && this.computedSlot.SectionSlots) {
            this.computedSlot.SectionSlots.forEach(section => {
              if (section.Type === SLOT_TYPES.SECTION_REST) {
                restMs += Math.max(new Date(section.To).getTime() - new Date(section.From).getTime(), 0);
              }
            });
          }

          const differenceHr = (differenceMs - restMs) / 1000 / 60 / 60;

          return {
            "has-overtime": this.branchSettings?.overtimeStartTimeHours != null
              && differenceHr > this.branchSettings.overtimeStartTimeHours,
          };
        },
        intervalClass() {
          return {
            "has-interval-alert": this.isLessThanInterval
          }
        },
        computeSlotClass() {
            return {
                'slot-padding': !this.isUsedInShiftPage,
                'slots-cont': true,
                'draggable': !this.isRepeat && !this.companyName  && !this.cellEditMode.isOn && !this.isUsedInShiftPage && !this.isReadOnly && !this.computedSlot.RepeatKey,
                'flex-column': this.slot.RequestedSlot,
            }
        },
        computeChipStyle() {
            let bg = this.computedSlot.Color ? `#${this.computedSlot.Color}` : '#ECEBEB';
            if (this.isSlotSelectedForDelete) {
                bg = "#e85600"
            }

            if (this.isClone) {
              const rgb = hexToRgb(bg);
              return {
                // Set opacity to 50% using rgb to avoid making alert child elements hard to read.
                'backgroundColor': rgb ? `rgb(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.5)` : 'rgb(236, 235, 235, 0.5)',
                'cursor': 'default',
              };
            }
            return {
                'backgroundColor': bg,
                'cursor': this.isCellDisabled ? 'not-allowed' : 'pointer',
            };
        },
        lockStyle() {
            return {
                'color': this.isKOTSynced ? '#1E9038' : '',
            }
        },
        borderClass() {
            if (!this.useShiftBorders) {
                return {};
            }
            return {
                'slot-outline': !this.isLocked && (!this.slot.RequestedSlot || this.isClone),
                'requested-slot-outline': !this.isLocked && this.slot.RequestedSlot && !this.isClone,
            }
        },
        slotWrapperClass() {
            if (!this.useShiftBorders) {
                return {};
            }
            return {
                'slot-wrapper': !this.isLocked && this.slot.RequestedSlot && !this.isClone,
            }
        },
        chipClass() {
            return {
                'disabled': this.isCellDisabled && !this.isClone,
                'text-light': this.computedSlot.Color || this.isSlotSelectedForDelete,
                'main-slot': this.hasRequestSlot && !this.isClone && !this.showRequestSlotOnly && !this.shouldHideRequestSlot,
            }
        },
        slotTextClass() {
            return {
              'clone': this.isClone,
              'text-light-clone': this.computedSlot.Color,
            }
        },
        slotNameClass() {
            return {
                'text-success': this.isTypeOne && !this.isSlotSelectedForDelete,
                'zmdi-hc-lg': this.isDefaultTextTypeTwo,
                'zmdi': this.isTypeTwo && !this.isRole,
                'text-error': this.isHolidayType && !this.isSlotSelectedForDelete,
            }
        },
        requestSlotNameClass() {
            return {
                'zmdi zmdi-hc-lg': this.isRequestDefaultTextTypeTwo
            }
        },
        isRequestSlotTypeTwo() {
            return this.slot?.RequestedSlot.Type === SLOT_TYPES.OFF_DAY;
        },
        isRequestDefaultTextTypeTwo() {
            return this.isRequestSlotTypeTwo && isSlotTypeXOffDayString(this.requestSlotName);
        },
        isNumWorkerEnabled() {
            return !this.isClone && !this.isHolidayType;
        },
        isTransportCostEnabled() {
            return this.isNumWorkerEnabled && !this.linkPrev;
        },
        companyName() {
            return this.isClone ? this.computedSlot.CompanyName : "";
        },
        isHelp() {
            return this.computedSlot.IsHelp;
        },
        isAuto() {
            return this.computedSlot.IsAuto;
        },
        isKOTSynced() {
            return this.computedSlot.KOTSynced;
        },
        isTypeOne() {
            return this.computedSlot.Type === 1;
        },
        isDefaultTextTypeTwo() {
            return this.isTypeTwo && this.slotName === '×';
        },
        isTypeTwo() {
            return this.computedSlot.Type === 2;
        },
        isHolidayType() {
            return this.computedSlot.Type > 1;
        },
        isRepeat() {
            return this.computedSlot.Repeat;
        },
        numComments() {
            return this.computedSlot.NumComments > 0 ? this.computedSlot.NumComments : 0;
        },
        rejectedAsk() {
            return this.computedSlot.AskStatus === 3 && this.meStore.getIsLeader();
        },
        askStatus() {
            return this.computedSlot.AskStatus;
        },
        isClone() {
            return this.computedSlot.CompanyID != this.meStore.getActiveBranchId()
        },
        isLocked() {
            if (this.isRepeat) {
                return this.isRepeatLocked;
            }

            return this.computedSlot.Locked;
        },
        isRole() {
            if (this.computedSlot.RoleID) {
                return true
            }
            return false
        },
        isGroupRole() {
          if (!this.isRole) {
            return false
          }
          return isSlotGroupRole(this.computedSlot);
        },
        isOrRole() {
          const roleId = this.slot.RoleID;
          if (!roleId) {
            return false
          }
          const role = this.roleStore.data?.[roleId];
          return Boolean(role?.isOrRole());
        },
        isMainRole() {
          const roleId = this.slot.RoleID;
          if (!roleId) {
            return false
          }
          const role = this.roleStore.data?.[roleId];
          return Boolean(role?.isMainRole());
        },
        isRepeatLocked() {
          if (!this.isRepeat) {
              return false;
          }
          const repeatDateZeroed = new Date(this.repeatDate).setUTCHours(0, 0, 0, 0);
          const ind = this.computedSlot.RepeatLocked?.findIndex(d => new Date(d).setUTCHours(0, 0, 0 ,0) === repeatDateZeroed);
          if (ind >= 0) {
              return true;
          }

          return false;
        },
        hasRequestSlot() {
            return this.slot.RequestedSlotID && this.slot.RequestedSlot;
        },
        hasLinkPrev() {
          const userTz = timeZones.ASIA_TOKYO;
          const dateInTz = dateFromString(this.date, userTz);
          const shift = parseShiftRaw(this.slot);
          let repeatDate = null;
          if (this.repeatDate) [
            repeatDate = new Date(this.repeatDate)
          ]
			    return shiftHasLinkPrev(shift, this.branchSettings, dateInTz, userTz, repeatDate);
        },
        hasLinkNext() {
          const userTz = timeZones.ASIA_TOKYO;
          const dateInTz = dateFromString(this.date, userTz);
          const shift = parseShiftRaw(this.slot);
          let repeatDate = null;
          if (this.repeatDate) [
            repeatDate = new Date(this.repeatDate)
          ]
			    return shiftHasLinkNext(shift, this.branchSettings, dateInTz, userTz, repeatDate);
        },
        isLessThanInterval() {
          const shiftInterval = Number(this.branchSettings.shiftInterval);
          const durationBeforeLastShift = this.durationBeforeLastShiftBySlotId?.[this.computedSlot.ID]?.[this.date];
          if (!shiftInterval || durationBeforeLastShift === null) {
            return false;
          }

          return durationBeforeLastShift < shiftInterval;
        },
        showAuto() {
          return !this.isLocked && this.isAuto;
        },
        slotName() {
          // No access to user display settings, so hardcode only supported tz for now.
          const userTz = timeZones.ASIA_TOKYO;
          const dateInTz = dateFromString(this.date, userTz);
          const tableDate = makeTableDate(dateInTz, periodTypes.DAY, userTz);
          let shift = parseShiftRaw(this.computedSlot);
          if (this.isRepeat) {
            const repeatTemplate = parseRepeatShiftTemplateOplusTimeRaw(this.computedSlot, timeZones.ASIA_TOKYO);
            // +- a day on either side to catch overnight slots
            const shifts = repeatShiftsFromTemplate(addDaysToDate(tableDate.getDate(), -1), addDaysToDate(tableDate.getEnd(), 1), repeatTemplate, userTz);
            shift = shifts[0];
          }
          if (!shift) {
            return "";
          }
          return shiftName(shift, this.branchSettings, tableDate.getDate(), tableDate.getEnd(), userTz);
        },
        requestSlotName() {
          if (!this.hasRequestSlot) {
            return ""
          }
          const tableDate = this.computeTableDate(this.date, timeZones.ASIA_TOKYO);
          let shift;
          if (this.isRepeat) {
            shift = this.computeRepeatShift(this.slot.RequestedSlot, tableDate, timeZones.ASIA_TOKYO)
          } else {
            shift = parseShiftRaw(this.slot.RequestedSlot);
          }

          if (!shift) {
            return "";
          }
          return shiftName(shift, this.branchSettings, tableDate.getDate(), tableDate.getEnd(), timeZones.ASIA_TOKYO);
        },
        shouldShowAlert() {
          return Boolean(this.meStore.getIsLeader() && this.slot.Alert && !this.rejectedAsk);
        },
        mountId() {
          return `${this.slot.ID}_${this.isRepeat ? goDateString(this.repeatDate) : this.date}`
        },
        fromUnix() {
          let fromUnix = this.slot.FromUnix;
          if (this.isRepeat) {
              fromUnix = this.repeatDate / 1000;
          }
          return fromUnix;
        },
        toUnix() {
          let toUnix = this.slot.ToUnix;
          if (this.isRepeat) {
              toUnix = this.fromUnix + (this.slot.ToUnix - this.slot.FromUnix);
          }
          return toUnix;
        },
        slotWage() {
          let wage = this.slotUserInfo.wage;
          if (this.slotRole && this.slotRole.Wage) {
              wage = this.slotRole.Wage;
          }
          return wage || 0;
        },
        slotUserInfo() {
          return findUserById(this.slot.UserID) || {};
        },
        slotRole() {
          return findRoleById(this.slot.RoleID);
        },
        numUnreadComments() {
            if (this.slotLogMap) {
                const slotLogs = this.slotLogMap[this.slot.ID];
                return slotLogs ? slotLogs.length : 0;
            }
            return 0;
        },
        showRequestSlotOnly() {
          return this.isCellDisabled && this.branchSettings.stackedRequest && !this.meStore.getIsLeader()
        },
        shouldHideRequestSlot() {
          // Hide request slots submitted by other staff if user is not a leader
          return !this.meStore.getIsLeader() && this.hasRequestSlot && this.slot.RequestedSlot.UserID !== this.meStore.me.getOriginalId();
        },
    },
    components: {
        GroupRoleIcon,
        SlotBadges,
        OrMainRoleIcon,
        OrSubRoleIcon,
        AutoIcon
    }
}
</script>

<template>
<div
    :id="`vue-slot-${mountId}`"
    :class="[computeSlotClass, slotWrapperClass, hasBeenReadClass, overTimeClass, intervalClass]"
    :data-slot-id="slot.ID"
    :data-from="fromUnix"
    :data-to="toUnix"
    :data-date="date"
    :data-user="slot.UserID"
    :data-type="slot.Type"
    :data-rest="slot.Rest"
    :data-label="slot.Label"
    :data-is-counted="!isHolidayType"
    :data-hide="slot.HideFrom || slot.HideTo"
    :data-hours="slot.TotalHours"
    :data-role-id="slot.RoleID"
    :data-is-clone="isClone"
    :data-slot-name="slotName"
>
    <!-- (for staff level perm) If cell is locked/closed and Request slot settings is ON, we only show slots submitted by staff -->
    <span 
      v-if="slot.RequestedSlot && !isClone && !showRequestSlotOnly && !shouldHideRequestSlot" 
      class="vue-chip chip requested-slot" 
      :class="borderClass" 
      @click="handleSlotClick"
    >
        <SlotBadges
            :num-read-comments="numComments"
            :num-unread-comments="numUnreadComments"
            :is-clone="isClone"
            :should-show-alert="shouldShowAlert"
            :alert-index="slot.Alert"
            :ask-status="askStatus"
            :tooltip-bottom="false"
            :exceed-weekly-limit="exceedWeeklyLimit"
        />

        <i v-if="slot.RequestedSlot.LinkPrev" class="icon icon-link"></i>
        <span class="text-ellipsis transparent" :class="requestSlotNameClass">
            {{ this.requestSlotName }}
        </span>
        <i v-if="slot.RequestedSlot.LinkNext" class="icon icon-link"></i>
    </span>

    <span
        class="chip vue-chip slot"
        :style="computeChipStyle"
        :class="[chipClass, borderClass]"
        @click="handleSlotClick"
        :id="`slot-${slot.ID}`"
    >
        <SlotBadges
            v-if="!slot.RequestedSlot || isClone || shouldHideRequestSlot"
            :num-read-comments="numComments"
            :num-unread-comments="numUnreadComments"
            :is-clone="isClone"
            :should-show-alert="shouldShowAlert"
            :alert-index="slot.Alert"
            :ask-status="askStatus"
            :tooltip-bottom="false"
            :exceed-weekly-limit="exceedWeeklyLimit"
        />

        <span class="slot-content flex-center" :class="slotTextClass">
          <GroupRoleIcon v-if="isGroupRole"/>
          <i v-if="isHelp" class="zmdi zmdi-assignment-return"></i>
          <small v-if="companyName">{{ companyName }}</small>
          <i v-if="hasLinkPrev" class="icon icon-link"></i>
          <i v-if="isLocked && !isKOTSynced && !useShiftBorders" class="icon icon-check"></i>
          <i v-if="isLocked && isKOTSynced" class="icon icon-check" :style="lockStyle"></i>
          <AutoIcon v-if="showAuto"/>
          <OrMainRoleIcon v-if="isMainRole"/>
          <OrSubRoleIcon v-if="isOrRole"/>
          <span v-if="isRepeat || computedSlot.RepeatKey">∞</span>
          <span ref="slotName" class="text-ellipsis" :class="slotNameClass">{{ slotName }}</span>
          <i v-if="hasLinkNext" class="icon icon-link"></i>
          <i v-if="isSlotSelectedForDelete" class="zmdi zmdi-delete"></i>
        </span>
    </span>
</div>
</template>

<style scoped>
  .disabled {
    opacity: 0.5;
  }

  /* Make clone text lighter than black used in normal slots */
  .clone {
    /* #3b4351 with opacity 50% */
    color: rgb(59, 67, 81, 0.5);
  }

  .text-light-clone {
    color: white;
  }

  .chip {
    padding: 0 0.4rem;
    position: relative;
    overflow: visible;
    vertical-align: top;
    margin: 0;
  }

  .requested-slot {
    opacity: 1;
    justify-content: center;
  }

  .transparent {
    opacity: 0.5;
  }

  .slot-wrapper {
    border-radius: 5px;
    outline: 1.5px dashed #646565;
    width: 94%;
    max-width: 200px;
  }

  .slot-outline {
    outline: 1.5px dashed #646565;
    border: none;
  }

  .requested-slot-outline {
    margin: 0;
    width: 100%;
    border: none;
  }

  .slots-cont {
    width: fit-content;
    max-width: 100%;
  }

  .vue-chip {
    width: 100%;
    max-width: 100%;
  }

  .slot-padding {
    padding: 0.175rem 0.2rem;
  }
  .read-receipt-active .is-not-read {
    background-color:  #F95B5B;
  }

  .slot-content {
    overflow: hidden;
    width: 100%;
  }

  .slot-content > * {
    margin: auto 2px;
  }

  .slot-content > i {
    flex: 0 0 auto;
  }
</style>
